import { Map, List } from 'immutable';

const generateSteps = (steps = []) => {
  let stepList = List();
  steps.forEach((step, idx) => {
    stepList = stepList.push(Map({ position: idx, code: step.code, type: step.type }));
  });
  return stepList;
};

const stepChanger = (increment = 1) => (payload = null) => {
  return (dispatch, getState) => {
    const step = getState().getIn(['customer', 'step']);
    const stepPosition = step.getIn(['current_step', 'position']);
    const newStepPosition = !payload ? stepPosition + increment : payload;

    let newStep = step.get('list').find(step => {
      return step.get('position') === newStepPosition || step.get('code') === newStepPosition;
    });
    newStep = newStep || getState().getIn(['customer', 'step', 'current_step']);
    //per incompatiblitat de redux-first i immutables es necessari realizar la conversió, c'est la vie.. :'(
    return newStep.toJS();
  };
};

export default {
  CHANGE: stepChanger(),
  NEXT: stepChanger(),
  PREV: stepChanger(-1),
  INITIALIZE: startValues => {
    return (dispatch, getState) => {
      const stepList = generateSteps(startValues.steps);
      let currentStepCode = startValues.current_step;

      currentStepCode = stepList.find(step => {
        return step.get('code') === currentStepCode;
      });
      if (!currentStepCode) {
        const defaultState = (window.frontLoader && window.frontLoader['cms-avail']?.defaultState) || window.defaultState;
        currentStepCode = stepList.find(step => {
          return step.get('code') === defaultState.step;
        });
        if (!currentStepCode) {
          currentStepCode = stepList.get(0);
        }
      }

      return Map({
        current_step: currentStepCode,
        required_params: List(startValues.required_params),
        list: stepList,
        loaded: true
      });
    };
  }
};
